// Tracking BooksPage.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getPageImageUrl } from '../data/pageData.jsx';
import { updatePageMeta, pageMeta } from '../utils/seo.jsx';
import ImageWithPlaceholder from './ImageWithPlaceholder.jsx';
export default function BooksPage() {
  const navigate = useNavigate();

  // Update SEO metadata for books page
  useEffect(() => {
    updatePageMeta(pageMeta.books);
  }, []);
  return <div className="w-full h-full flex items-center justify-center relative" style={{
    backgroundColor: '#faf8f5',
    minHeight: '100vh',
    padding: '2rem'
  }}>
      {/* Back to Home Link */}
      <a href="/" className="fixed top-8 left-8 opacity-60 hover:opacity-100 transition-opacity duration-300" style={{
      fontFamily: "'Inter', -apple-system, sans-serif",
      fontSize: '0.85rem',
      fontWeight: 300,
      color: '#5a5650',
      letterSpacing: '0.1em',
      textDecoration: 'none',
      textTransform: 'lowercase'
    }} data-tracking-id="link-81be8be1e92f019f">
        ← home
      </a>

      {/* Main Content */}
      <main className="text-center">
        {/* Page Title */}
        <h1 className="mb-12" style={{
        fontFamily: "'Cormorant Garamond', Georgia, serif",
        fontSize: 'clamp(2rem, 6vw, 3rem)',
        fontWeight: 400,
        color: '#2a2825',
        letterSpacing: '0.08em'
      }}>
          Books
        </h1>

        {/* Book Card */}
        <div onClick={() => navigate('/books/empire-freedom')} className="cursor-pointer group" style={{
        maxWidth: '380px',
        margin: '0 auto'
      }}>
          {/* Book Cover */}
          <div className="relative overflow-hidden rounded-sm transition-all duration-300 shadow-lg hover:scale-105" style={{
          aspectRatio: '567 / 800',
          backgroundColor: '#faf8f5',
          marginBottom: '1.5rem',
          width: '100%'
        }}>
            <ImageWithPlaceholder src="https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2RBkUqh3LVjYlDQLDGXc6cEkFC7/cover-ww5w0xtvzkq.jpg" alt="Empire & Freedom Cover" className="w-full h-full object-cover" />
            
            {/* Hover Overlay */}
            <div className="absolute inset-0 bg-stone-dark bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 rounded-sm flex items-center justify-center">
              <button className="btn-primary opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-tracking-id="btn-57fc2e731d515649">
                Learn More
              </button>
            </div>
          </div>

          {/* Book Info */}
          <h2 className="transition-colors duration-300" style={{
          fontFamily: "'Cormorant Garamond', Georgia, serif",
          fontSize: 'clamp(1.5rem, 4vw, 2rem)',
          fontWeight: 400,
          color: '#2a2825',
          letterSpacing: '0.05em',
          marginBottom: '0.5rem'
        }}>
            Empire & Freedom
          </h2>
          
          <p style={{
          fontFamily: "'Inter', -apple-system, sans-serif",
          fontSize: '0.85rem',
          fontWeight: 300,
          color: '#5a5650',
          letterSpacing: '0.05em',
          lineHeight: '1.6',
          maxWidth: '380px'
        }}>
            The first AI-generated comic book on Indian history. 350 years of colonial rule reimagined through visual storytelling.
          </p>
        </div>
      </main>
    </div>;
}